import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { ModalWrapper, ModalContent, CloseButton, Title, QRCodeWrapper, Description } from './ModalWeChatShareStyle';

interface ModalWeChatShareProps {
    url: string;
    setIsWeChatModal: (isModal: boolean) => void;
}

const ModalWeChatShare: React.FC<ModalWeChatShareProps> = ({ url, setIsWeChatModal }) => {
    const { t } = useTranslation();

    return (
        <ModalWrapper onClick={() => setIsWeChatModal(false)}>
            <ModalContent onClick={(e) => e.stopPropagation()}>
                <CloseButton onClick={() => setIsWeChatModal(false)}>&times;</CloseButton>
                <Title>{t('shareWeChat')}</Title>
                <Description>{t('scanQRWeChat')}</Description>
                <QRCodeWrapper>
                    <QRCodeSVG value={url} size={200} />
                </QRCodeWrapper>
            </ModalContent>
        </ModalWrapper>
    );
};

export default ModalWeChatShare;